/**
 * Tailwind CSS implementation of Tooltip content
 * Uses Seeds tooltip CSS classes from tooltip.css
 */

import React from "react";

// Utility for merging class names properly
function cn(
  ...inputs: (string | undefined | null | false | Record<string, boolean>)[]
): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === "string") {
      classes.push(input);
    } else if (typeof input === "object") {
      for (const [key, value] of Object.entries(input)) {
        if (value) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}

export interface TypeTooltipTailwindProps
  extends React.HTMLAttributes<HTMLDivElement> {
  appearance?: "pill" | "box";
}

export const TooltipTailwind = React.forwardRef<
  HTMLDivElement,
  TypeTooltipTailwindProps
>(({ appearance, className, ...rest }, ref) => (
  <div
    ref={ref}
    role="tooltip"
    className={cn(
      "seeds-tooltip",
      appearance === "box" ? "seeds-tooltip-box" : "seeds-tooltip-pill",
      className
    )}
    {...rest}
  />
));

TooltipTailwind.displayName = "TooltipTailwind";
